import { get } from './client.js';

export const getHealth = (orgId) => get(`/orgs/${orgId}/health`);
